import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import consoleDeprecated from '../utils/console-deprecated';
import { Table as StyledTable } from './styles';
let wasDeprecationMsgPrinted = false;
const Table = ({
  children = null,
  striped = false,
  bordered = false,
  padded = false,
  responsive = false,
  className = null,
  ...props
}) => {
  if (striped && !wasDeprecationMsgPrinted) {
    consoleDeprecated('striped prop on Table component is deprecated and will be removed on the next major release.');
    wasDeprecationMsgPrinted = true;
  }
  return /*#__PURE__*/React.createElement(StyledTable, _extends({
    "data-padded": padded,
    "data-responsive": responsive,
    className: cx(className, 'table', {
      'table--striped': striped
    }, {
      'table--row-bordered': bordered
    })
  }, props), children);
};
Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  striped: PropTypes.bool,
  bordered: PropTypes.bool,
  padded: PropTypes.bool,
  responsive: PropTypes.bool
};
export default Table;
//# sourceMappingURL=index.js.map